module.exports = __webpack_public_path__ + "img/two_code.013c0a54.png";